
import apiConfig from '@/config/api.config'

export default {
  name: 'Dashboard',
  data () {
    return {
      amountVisible: false,
      stats: {
        totalOrders: 0,
        totalRevenue: 0,
        totalUsers: 0,
        totalProducts: 0,
        pendingOrders: 0,
        pendingUsers: 0
      }
    }
  },
  created () {
    this.fetchStats()
  },
  methods: {
    async fetchStats () {
      try {
        const token = localStorage.getItem('token')
        const res = await this.axios.get(apiConfig.apiList.getStats, {
          headers: { Authorization: `Bearer ${token}` }
        })
        if (res.data.code === 200) {
          this.stats = res.data.data
        }
      } catch (err) {
        console.error('获取统计数据失败:', err)
      }
    },
    formatMoney (amount) {
      return (amount || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
  }
}
